import { DatePipe, DecimalPipe } from "@angular/common";
import { Component, InputSignal, input, inject, computed } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { Router } from "@angular/router";
import { InvoiceDto } from "../../../../../../../api/models/fraud.models";
import { dialogRiseSlowAnimation, sparklePopAnimation } from "../../../../../../animations/pricing-animations";
import { getPriceRange, groupCostProviders } from "../../../../../../utils/pricing.utils";

@Component({
  selector: 'app-plan-upgrade-renew-paid',
  imports: [
    MatIcon,
    DatePipe,
    DecimalPipe
  ],
  templateUrl: './plan-upgrade-renew-paid.component.html',
  styleUrl: './plan-upgrade-renew-paid.component.scss',
  host: {
    class: 'block'
  },
  animations: [dialogRiseSlowAnimation, sparklePopAnimation]
})
export class PlanUpgradeRenewPaidComponent {
  public readonly invoice: InputSignal<InvoiceDto> = input.required<InvoiceDto>();

  readonly matDialogRef = inject(MatDialogRef);
  readonly router = inject(Router);

  readonly priceRange = computed(() => {
    const plan = this.invoice()?.userPlan;
    if (!plan) return '0.00';
    return getPriceRange(groupCostProviders(plan));
  });
  
  public goToDashboard(): void {
    this.matDialogRef.close();
    this.router.navigate(['/']);
  }

  // public downloadInvoice(): void {
  //   this.matDialogRef.close();
  //   this.router.navigate(['/balance'], { queryParams: { tabIndex: 1 } });
  // }
}
